export enum TimeAgo {
  TWOMONTHAGO = "60daysAgo",
  MONTHAGO = "30daysAgo",
  WEEKAGO = "7daysAgo",
  THREEDAYSAGO = "3daysAgo",
}
